export const home =  {

    "heading1_hero_section" : "High Impact Disaster Management Research",

    "heading2_hero_section" : "Queensland Disaster Research Alliance",

    "heading3_hero_section" : "Collaboration that Aims to Grow   ",


    "heading1_intro_section" : "Queensland Disaster Research Alliance ",

    "heading2_intro_section" : "",
    "text1_intro_section" : "",

    "text2_intro_section" : "Use the resources below to learn more about why you should retrofit, " +
    "how winds affect houses, and getting approvals to carry out retrofits.",


    "heading_middle_section" : "Our Mission",

    "text_middle_section" : "The Queensland Disaster Research Alliance (QDRA) is a cooperative agreement between seven Queensland universities to foster collaboration and the development of new grant consortia to: \n" +
    "\n" +
    "Enhance Queensland’s disaster research grant strength and success through strategic inter-university partnerships which maximise the strengths of the partners.\n" +
    "Identify and negotiate new funding opportunities to deliver improved success in competitive grant. \n" +
    "Work with relevant industry and operational agencies to deliver high impact, at-scale disaster management research outcomes for Queensland.",

    "heading_end_section" : "BACKED BY RESEARCH",

    "text1_end_section" : "The following graph shows how different levels of maintenance and retrofitting can protect an older (pre-1980s) house from damage at different wind speeds. " +
    "The effectiveness of retrofitting has been quantified using detailed vulnerability modelling using wind tunnel testing, structural analysis and statistical analysis.",


    "heading_resources_section" : "PROJECTS",

    "heading_examples_section" : "EXAMPLES OF WIND DAMAGE",

    "heading_video_section" : "PARTNERS",

}